import {
  REQUEST_STOREWASTESTATISTICS_BY_PRODUCT,
  REQUEST_STOREWASTESTATISTICS_BY_PRODUCT_DONE,
  ProductWasteStatisticsActions
} from "./types";
import { ProductWasteStatistics } from "../../../models/Statistics";
import * as StatisticsApi from "../../../api/statisticsApi";
import { isOk } from "../../../result";

function fetchStoreWasteByProductStatistics(): ProductWasteStatisticsActions {
  return {
    type: REQUEST_STOREWASTESTATISTICS_BY_PRODUCT,
    payload: []
  };
}

function fetchStoreWasteByProductStatisticsDone(
  productWasteStatistics: ReadonlyArray<ProductWasteStatistics>
): ProductWasteStatisticsActions {
  return {
    type: REQUEST_STOREWASTESTATISTICS_BY_PRODUCT_DONE,
    payload: productWasteStatistics
  };
}

/* Thunks goes here */
export const thunkFetchProductWasteStatistics = (
  periodFrom: Date,
  periodTo: Date,
  storeId: string
) => async (dispatch: any) => {
  try {
    dispatch(fetchStoreWasteByProductStatistics());
    const result = await StatisticsApi.getProductWasteStatistics(
      periodFrom,
      periodTo,
      storeId
    );

    if (isOk(result)) {
      dispatch(fetchStoreWasteByProductStatisticsDone(result.value));
    } else {
      console.log(result.details);
      dispatch(fetchStoreWasteByProductStatisticsDone([]));
    }
  } catch (error) {
    console.log(error);
  }
};
